import * as yup from "yup";

export default messages => {
  return yup.object().shape({
    passcode: yup.string().required(messages.REQUIRED)
  });
};
